import type { CarDetailsErrorCauses } from '../errors/car-details';
import type { CarListErrorCauses } from '../errors/car-list';
import type { ConfigErrorCauses } from '../errors/config';

export enum Errors {
    API = 'ApiError',
    CAR_DETAILS = 'CarDetailsError',
    CAR_LIST = 'CarListError',
    CONFIG = 'ConfigError',
    ERROR = 'Error',
    MODULE_DISABLED = 'ModuleDisabledError',
}

export enum ErrorAction {
    NONE = 'none',
    EXIT = 'exit',
    HOME = 'home',
    RELOAD = 'reload',
}

export type FunctionOutputTypeError = {
    action: ErrorAction;
    description: string;
    function: string;
    heading: string;
    message: string;
    stack: string | undefined;
    status: number;
} & (
    | {
          api: string;
          errorObject: Record<string, unknown>;
          name: Errors.API;
      }
    | {
          cause: CarDetailsErrorCauses;
          name: Errors.CAR_DETAILS;
      }
    | {
          cause: CarListErrorCauses;
          name: Errors.CAR_LIST;
      }
    | {
          cause: ConfigErrorCauses;
          name: Errors.CONFIG;
      }
    | {
          errorObject: Error;
          name: Errors.ERROR;
      }
    | {
          name: Exclude<Errors, Errors.API | Errors.CAR_DETAILS | Errors.CAR_LIST | Errors.CONFIG | Errors.ERROR> | `UnhandledError:${string}`;
      }
);

export interface FunctionOutputType<SuccessOutputType> {
    status: number;
    output: SuccessOutputType;
}

export interface FunctionOutputTypeErrorReturn {
    status: number;
    output: FunctionOutputTypeError;
}
